import * as React from 'react'
import {useEffect, useState} from "react";
import {createRoot} from "react-dom/client";
import { decode } from 'html-entities';

const dateTimeFormat = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
});

function NewsMediaListingPage() {
    const defaultResults = { hits: [], totalPages: 0 };
    const [category, setCategory] = useState(null);
    const [author, setAuthor] = useState(null);
    const [mediaTypes, setMediaTypes] = useState([]);
    const [query, setQuery] = useState('');
    const [results, setResults] = useState(defaultResults);
    const [page, setPage] = useState(1);

    const urlParams = new URLSearchParams(window.location.search);
    let urlCategory = urlParams.get('t')?.split(',') || [];

    //note:  This is the wrong way to do this
    //the content editors in the CrownPeak site used this.  It's a misuse of how the url should be done
    //they wanted to keep the urls this way though
    const urlCategoryPosition = window.location.href.lastIndexOf('t=');
    if (urlCategoryPosition > 0) {
        urlCategory.push(decodeURIComponent(window.location.href.substring(urlCategoryPosition + 2)));
    }

    const [queryStringMediaTypes, _] = useState(urlCategory);

    const setTag = (tag) => {
        setQuery(`tag:${tag.value}`);
    }

    const setQueryStringMediaTypes = (names) => {
        window.history.pushState({}, '', `?t=${names.join(',')}`);
    }

    useEffect(() => {
        setPage(1)
    }, [category, author, mediaTypes, query]);

    useEffect(() => {
        const payload = {
            categoryIds: (category !== null ? [category] : null),
            authorIds: (author !== null ? [author] : null),
            mediaTypeIds: (mediaTypes.length > 0 ? mediaTypes : null),
            query: query,
            page: page
        }

        const fetchResults = async () => {
            try {
                const response = await fetch('/api/news/search', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                if (!response.ok) {
                    console.error('Failed to fetch results:', response.statusText);
                    return {};
                }
                return await response.json();
            } catch (error) {
                console.error('Error fetching results:', error);
                return {};
            }
        };

        fetchResults()
            .then(data => setResults(data))
            .catch(error => {
                console.error('Error setting results:', error);
                setResults({...defaultResults});
            });
    }, [category, author, mediaTypes, query, page]);

    return (
        <div className='news-media-listing-page-wrapper'>
            <div className='right-section'>
                <SearchFilters
                    query={query}
                    category={category}
                    author={author}
                    mediaTypes={mediaTypes}
                    queryStringMediaTypes={queryStringMediaTypes}
                    setQueryStringMediaTypes={setQueryStringMediaTypes}
                    onCategoryChange={setCategory}
                    onAuthorChange={setAuthor}
                    onMediaTypesChange={setMediaTypes}
                    onQueryChange={setQuery}
                />
            </div>

            <div className='left-section'>
                <SearchResults
                    results={results}
                    page={page}
                    setPage={setPage}
                    setAuthor={setAuthor}
                    setCategory={setCategory}
                    setTag={setTag}
                />
            </div>
        </div>
    );
}

function SearchFilters({query, category, author, mediaTypes, onCategoryChange, onAuthorChange, onMediaTypesChange, onQueryChange, queryStringMediaTypes, setQueryStringMediaTypes}) {
    const [facets, setFacets] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState({
        category: false,
        author: false,
    });
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const handleDropdownToggle = (filter) => {
        setDropdownOpen((prevState) => ({
            category: filter === 'category' ? !prevState.category : false,
            author: filter === 'author' ? !prevState.author : false,
        }));
    };

    const handleClickOutside = (event) => {
        if (!event.target.closest('.custom-dropdown-item')) {
            setDropdownOpen({ category: false, author: false });
        }
    };

    const handleMediaTypesChange = (selectedMediaTypes) => {
        const names = facets['mediaTypes'].filter(t => selectedMediaTypes.includes(t.id)).map(t => t.value);
        setQueryStringMediaTypes(names);
        onMediaTypesChange(selectedMediaTypes);
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        const fetchFacets = async () => {
            try {
                const response = await fetch('/api/news/facets');
                if (!response.ok) {
                    console.error('Failed to fetch facets:', response.statusText);
                    return {};
                }
                return await response.json();
            } catch (error) {
                console.error('Error fetching facets:', error);
                return {};
            }
        };

        fetchFacets()
            .then(data => {
                const types = data['mediaTypes'] || [];
                const selectedTypes = types.filter(t => queryStringMediaTypes.includes(t.value));
                setFacets(data);
                if (selectedTypes) {
                    onMediaTypesChange(selectedTypes.map(t => t.id));
                }
            })
            .catch(error => {
                console.error('Error setting facets:', error);
                setFacets({});
            });
    }, []);

    return (
        <div>
            <div className='blue-heading filter-heading'>Filters</div>

            <div className="dropdown-wrappers">

                {facets['categories'] && (
                    <div className="custom-dropdown">
                        <div className="custom-dropdown-item category">
                            <label className="sr-only">Filter By Category:</label>
                            <button
                                className={`dropdown-button ${dropdownOpen.category ? 'opened' : ''}`}
                                onClick={() => handleDropdownToggle('category')}
                            >
                                <span className="selected-option">
                                    {facets['categories'].length
                                        ? (facets['categories'].find(c => c.id === category)?.value || 'Filter By Category')
                                        : 'No Categories Available'
                                    }
                                </span>
                            </button>
                            <ul className={`dropdown-menu ${dropdownOpen.category ? 'show' : ''}`}>
                                <li
                                    className={`dropdown-item ${!category ? 'active' : ''}`}
                                    onClick={() => { onCategoryChange(null); setDropdownOpen({ ...dropdownOpen, category: false }) }}
                                >
                                    Filter By Category
                                </li>
                                {facets['categories'].map(categoryOption => (
                                    <li
                                        key={categoryOption.id}
                                        className={`dropdown-item ${category === categoryOption.id ? 'active' : ''}`}
                                        onClick={() => { onCategoryChange(categoryOption.id); setDropdownOpen({ ...dropdownOpen, category: false }) }}
                                    >
                                        {categoryOption.value}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}

                {facets['authors'] && (
                    <div className="custom-dropdown">
                        <div className="custom-dropdown-item author">
                            <label className="sr-only">Filter By Author:</label>
                            <button
                                className={`dropdown-button ${dropdownOpen.author ? 'opened' : ''}`}
                                onClick={() => handleDropdownToggle('author')}
                            >
                                <span className="selected-option">
                                    {facets['authors'].length
                                        ? (facets['authors'].find(a => a.id === author)?.value || 'Filter By Author')
                                        : 'No Authors Available'
                                    }
                                </span>
                            </button>
                            <ul className={`dropdown-menu ${dropdownOpen.author ? 'show' : ''}`}>
                                <li
                                    className={`dropdown-item ${!author ? 'active' : ''}`}
                                    onClick={() => { onAuthorChange(null); setDropdownOpen({ ...dropdownOpen, author: false }) }}
                                >
                                    Filter By Author
                                </li>
                                {facets['authors'].map(authorOption => (
                                    <li
                                        key={authorOption.id}
                                        className={`dropdown-item ${author === authorOption.id ? 'active' : ''}`}
                                        onClick={() => { onAuthorChange(authorOption.id); setDropdownOpen({ ...dropdownOpen, author: false }) }}
                                    >
                                        {authorOption.value}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}

                <SearchTerm
                    value={query}
                    onSubmit={onQueryChange}
                />
            </div>

            {facets['mediaTypes'] && (
                <div className={`media-type-wrapper ${isCollapsed ? "collapse" : ""}`}>
                    <div className="media-type-trigger">
                        <button className="show-card" onClick={toggleCollapse} >
                            <div className='blue-heading media-heading'>Select Media Type</div>
                            <svg className="show" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                <g fill="none" fill-rule="evenodd" stroke="#2B6D9F" stroke-linecap="square">
                                    <path d="M5.938 1v10M11 6H1"></path>
                                </g>
                            </svg>
                            <svg className="hide" xmlns="http://www.w3.org/2000/svg" width="12" height="2" viewBox="0 0 12 2">
                                <path fill="none" fill-rule="evenodd" stroke="#2B6D9F" stroke-linecap="square" d="M11 1H1"></path>
                            </svg>
                        </button>
                    </div>

                    <div className="media-type-content">
                        <FacetCheckboxList facetValues={facets['mediaTypes']}
                            onChange={handleMediaTypesChange}
                            selectedValues={mediaTypes}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

function SearchResults({results, page, setPage, setCategory, setAuthor, setTag}) {
    if (!results.hits || results.hits.length === 0) {
        return <div>No results were found.</div>;
    }

    return (
        <div className='news-media-list'>
            {results.hits.map((result) =>
                <SearchResult
                    key={result.id}
                    result={result}
                    setAuthor={setAuthor}
                    setCategory={setCategory}
                    setTag={setTag}/>)}

            <Pager
                pageCount={results.totalPages}
                pageNumber={page}
                setPageNumber={setPage}
            />
        </div>
    );
}

function Pager({ pageCount, pageNumber, setPageNumber }) {
    const canGoBack = pageNumber > 1;
    const canGoForward = pageNumber < pageCount;

    return (
        <div className="pagination-wrapper">
            <div className="pagination-container">
                <div className="pagination">
                    {canGoBack && (
                        <button
                            className="prev-page page-btn"
                            onClick={(e) => { e.preventDefault(); setPageNumber(pageNumber - 1); }}
                        >
                            <span className="sr-only">previous page</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10">
                                <g fill="none" fillRule="evenodd" stroke="#000">
                                    <path strokeLinecap="square" d="M1.491 5H16" />
                                    <path d="M5 .8L1 5.08 5 8.8" />
                                </g>
                            </svg>
                        </button>
                    )}

                    <div className="page-result">
                        Page <span className="current-page">{pageNumber}</span> of <span className="total-pages">{pageCount}</span>
                    </div>

                    {canGoForward && (
                        <button
                            className="next-page page-btn"
                            onClick={(e) => { e.preventDefault(); setPageNumber(pageNumber + 1); }}
                        >
                            <span className="sr-only">next page</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10">
                                <g fill="none" fillRule="evenodd" stroke="#000">
                                    <path strokeLinecap="square" d="M15.509 5H1" />
                                    <path d="M12 .3l4.49 4.674L12 9.65" />
                                </g>
                            </svg>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

function SearchResult({result, setCategory, setAuthor, setTag}) {
    const defaultImages = {
        "Blog": "/images/thumbnail-blog-wide@2x.png",
        "Press Release": "/images/thumbnail-pressrelease-wide@2x.png",
        "Insights & Ideas": "/images/thumbnail-ideas-wide@2x.png",
        "Analyst Appearance": "/images/thumbnail-analyst-wide@2x.png",
        "Market Strategy": "/images/thumbnail-market-wide@2x.png",
        "Podcast": "/images/thumbnail-ideas-wide@2x.png"
    };

    // Determine the image source
    const imageSrc = result.image
        ? <SearchResultImage image={result.image} />
        : <img src={defaultImages[result.mediaType] || "default-thumbnail.png"} alt={result.mediaType} />;

    const publishDate = result.publishDate ? new Date(result.publishDate) : null;

    const isExternal = result.url.startsWith("/") ? false : URL.canParse(result.url) ? new URL(result.url).host != window.location.host : false;

    return (
        <div className='news-media-item'>
            <div className="news-media-image-wrapper">
                <a href={result.url}>
                    {imageSrc}
                </a>
            </div>
            <div className="news-media-info-wrapper">
                <div className="blue-heading article-category" onClick={() => setCategory(result.categoryId)}>{result.category}</div>
                <h2 className="article-title">
                    <a href={result.url} {...(isExternal ? { className: "external-site-link", "data-toggle":"modal", "data-target":"#modal-leave-site-confirmation"} : {})}>
                        {decode(result.title)}
                    </a>
                </h2>
                <div className="article-author-date">
                    <span className="author-name" onClick={() => setAuthor(result.authorId)}>{result.authorName}</span>
                    <span className="article-date">{dateTimeFormat.format(publishDate)}</span>
                </div>
                <div className="article-tags">
                    {result.tags.map((tag) => <a className="article-tag" key={tag.id} onClick={() => setTag(tag)}>{tag.title}</a>)}
                </div>
            </div>
        </div>
    );
}

function SearchResultImage({image})
{
    return (
        <picture>
            {image.mobileImageAssetUrl && <source media="(max-width: 768px)" srcSet={image.mobileImageAssetUrl} />}
            {image.tabletImageAssetUrl && <source media="(max-width: 992px)" srcSet={image.tabletImageAssetUrl} />}
            {image.desktopImageAssetUrl && <img src={image.desktopImageAssetUrl} alt={image.altText} />}
        </picture>
    );
}

function SearchTerm({value, onSubmit}) {
    const [searchTerm, setSearchTerm] = useState(value);

    useEffect(() => {
        setSearchTerm(value);
    }, [value]);

    const onSearchTermChanged = (e) => {
        setSearchTerm(e.target.value);
    };

    const onSearchClicked = () => {
        onSubmit(searchTerm);
    };

    return (
        <div className='custom-search'>
            <div className='search-input-wrapper'>
                <label className="sr-only">Term:</label>
                <input
                    value={searchTerm}
                    onChange={onSearchTermChanged}
                    placeholder="Enter Search term"
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onSearchClicked();
                        }
                    }}
                />
            </div>
            <button className='search-button' onClick={onSearchClicked}>
                <span className='sr-only'>Search</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                    <path d="M15.849 15.13l-4.132-4.065a6.534 6.534 0 0 0 1.747-4.44C13.464 2.965 10.45 0 6.732 0 3.014 0 0 2.966 0 6.625c0 3.658 3.014 6.624 6.732 6.624a6.77 6.77 0 0 0 4.237-1.48l4.147 4.082c.202.199.53.199.732 0a.504.504 0 0 0 0-.721zm-9.117-2.9c-3.146 0-5.696-2.51-5.696-5.605 0-3.096 2.55-5.606 5.696-5.606s5.696 2.51 5.696 5.606c0 3.095-2.55 5.605-5.696 5.605z"/>
                </svg>
            </button>
        </div>
    );
}

function FacetCheckboxList({facetValues, onChange, selectedValues}) {
    const handleOnChange = (value, enabled) => {
        return enabled
            ? onChange([...selectedValues, value])
            : onChange(selectedValues.filter(id => id !== value));
    };

    const handleSelectAllChange = (enabled) => {
        if (enabled) {
            onChange([]);
        }
    };

    const isAllSelected = selectedValues.length === 0;

    return (
        <ul>
            <li>
                <label>
                    <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={(e) => handleSelectAllChange(e.target.checked)}
                    />
                    Select All
                </label>
            </li>
            {facetValues.map(value => (
                <li key={value.id}>
                    <label>
                        <input
                            type="checkbox"
                            checked={selectedValues.includes(value.id)}
                            onChange={(e) => handleOnChange(value.id, e.target.checked)}
                        />
                        {value.value}
                    </label>
                </li>
            ))}
        </ul>
    );
}

const domNode = document.getElementById('news-media-listing-page-component-root');
const root = createRoot(domNode);
root.render(<NewsMediaListingPage />);
